import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '../src/store/index'
import ElementUI from 'element-ui'
import VueVideoPlayer from 'vue-video-player'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import 'swiper/css/swiper.css'
import 'video.js/dist/video-js.css'
import '../src/common/common.scss'
import '../src/common/animation.scss'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/theme/index.css'

Vue.config.productionTip = false
// Vue.use(VueVideoPlayer,ElementUI);
Vue.use(VueVideoPlayer);
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper);
Vue.use(Donut);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
